/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EpaOperatorNotification } from './EpaOperatorNotification';
import {
    EpaOperatorNotificationFromJSON,
    EpaOperatorNotificationFromJSONTyped,
    EpaOperatorNotificationToJSON,
    EpaOperatorNotificationToJSONTyped,
} from './EpaOperatorNotification';

/**
 * 
 * @export
 * @interface PaginatedEpaOperatorNotificationList
 */
export interface PaginatedEpaOperatorNotificationList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedEpaOperatorNotificationList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedEpaOperatorNotificationList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedEpaOperatorNotificationList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<EpaOperatorNotification>}
     * @memberof PaginatedEpaOperatorNotificationList
     */
    results: Array<EpaOperatorNotification>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedEpaOperatorNotificationList
     */
    numPages?: number;
}

/**
 * Check if a given object implements the PaginatedEpaOperatorNotificationList interface.
 */
export function instanceOfPaginatedEpaOperatorNotificationList(value: object): value is PaginatedEpaOperatorNotificationList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedEpaOperatorNotificationListFromJSON(json: any): PaginatedEpaOperatorNotificationList {
    return PaginatedEpaOperatorNotificationListFromJSONTyped(json, false);
}

export function PaginatedEpaOperatorNotificationListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedEpaOperatorNotificationList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(EpaOperatorNotificationFromJSON)),
        'numPages': json['num_pages'] == null ? undefined : json['num_pages'],
    };
}

export function PaginatedEpaOperatorNotificationListToJSON(json: any): PaginatedEpaOperatorNotificationList {
    return PaginatedEpaOperatorNotificationListToJSONTyped(json, false);
}

export function PaginatedEpaOperatorNotificationListToJSONTyped(value?: PaginatedEpaOperatorNotificationList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(EpaOperatorNotificationToJSON)),
        'num_pages': value['numPages'],
    };
}

